import PaperclipIcon from 'assets/icons/paperclip-icon.svg?component'
import { ChangeEvent, Fragment, ReactNode, useId } from 'react'
import { useTranslation } from 'react-i18next'
import tw, { TwStyle } from 'twin.macro'

import Typography from '../Typography'
import Heading from '../Typography/Heading'

type FileInputProps = {
  disabled?: boolean
  name?: string
  subText?: ReactNode
  error?: string
  accept?: string
  twStyle?: TwStyle
  placeholder?: string
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
}

const FileInput = ({
  subText,
  error,
  name,
  placeholder = 'flow-load',
  disabled,
  accept = 'application/pdf',
  twStyle,
  onChange
}: FileInputProps) => {
  // Tools
  const id = useId()
  const { t } = useTranslation()

  // Handlers
  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e)
  }

  return (
    <Fragment>
      <label
        id={id}
        css={[
          tw`px-5 py-3 flex justify-between rounded-[14px] bg-stroke max-w-[335px] w-full cursor-pointer`,
          disabled && tw`opacity-50 cursor-not-allowed`,
          twStyle
        ]}
      >
        <input
          disabled={disabled}
          id={id}
          type='file'
          tw='hidden'
          name={name}
          accept={accept}
          onChange={handleInputChange}
        />
        <Heading twStyle={tw`text-primary-middle text-[14px] leading-[18px] tracking-[-0.15px]`} variant='subtitle'>
          {t(placeholder)}
        </Heading>
        <PaperclipIcon />
      </label>
      {error ||
        (subText && (
          <Typography text twStyle={tw`text-red-light text-xs mt-1`}>
            {error || subText}
          </Typography>
        ))}
    </Fragment>
  )
}

export default FileInput
